<template>
  <AlertConfirmModal ref="alertConfirmModal"/>
  <div class="header">
    <div class="container-fluid">
      <div style="display: flex;align-items: center;">
        <v-icon icon="mdi-menu" size="lg" style="margin-right: 15px;cursor: pointer; float: left;" class="app-menu-trigger" @click="$parent.appMenuTrigger"/>
        <div class="d-flex align-items-end clickable" style="width: var(--cui-sidebar-width, 0);" @click="goToDashboard">
          <img src="@/assets/images/Icon-128x128.png" style="width: 45px;margin-right: 20px" alt="" class="">
          <div>
            <div style="color:#6c6c6c; font-size: 1.5em" :title="version">OneConsole</div>
            <div style="color:#6c6c6c; font-size: 8px;align-self: end;text-align: right"
                 :title="getVersion">v{{ getVersion }}
            </div>
          </div>
        </div>
        <!-- <AppHeaderDepartment/> -->
      </div>
      <div class="header-nav" role="navigation">
        <AppHeaderDropdownCid />
        <AppHeaderDropdownNotif/>
        <AppHeaderDropdownAccount @logout="handleLogout"/>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeaderDropdownCid from "./AppHeaderDropdownCid"
import AppHeaderDropdownNotif from "./AppHeaderDropdownNotif"
// import AppHeaderDepartment from "./AppHeaderDepartment"
import AppHeaderDropdownAccount from "./AppHeaderDropdownAccount"
import Version from "@/scripts/version"
import imanager3Appframe from "@/scripts/imanager3-appframe";
import iStoreUtils from "@/scripts/istore-utils.js"

export default {
  name: 'AppHeader',
  components: {
    // AppHeaderDepartment,
    AppHeaderDropdownAccount,
    AppHeaderDropdownCid,
    AppHeaderDropdownNotif
  },
  data() {
    return {
      version: Version
    }
  },
  created() {
  },
  methods: {
    goToRoleDefault() {
      const isReseller = (this.$store.state.loginUser.roles || []).some(r => r.name === 'orion_reseller')
      if (isReseller) {
        const target = (this.$store.state.loginUser.userFunctions || []).find(
          f => f.module === 'cloudPlugin' && f.name === 'starNumInfo'
        )
        if (target) {
          this.$store.commit('setCurrentMenu', target)
          this.$store.commit('setChosenUrlValidity', true)
          // Navigate to home layout so AppFrame renders currentMenu
          if (this.$route.path !== '/home') {
            this.$router.replace('/home')
          } else {
            this.$router.replace({ path: '/home', query: { target: 'starNumInfo', ts: Date.now() } })
          }
          return true
        }
      }
      return false
    },
    goToDashboard() {
      if (this.goToRoleDefault()) return

      this.sendTrackingAction(
        this.$store.state.loginUser.userId,
        "Load Page",
        {
          "page": "Dashboard"
        }
      )
      if (this.$route.path !== '/dashboard') {
        this.$router.replace('/dashboard')
      }
      this.$store.commit('setCurrentMenu')
    },
    showHideSidebar() {
      this.$store.commit('toggleUnfoldable')
      if (!this.$store.state.sidebarVisible) {
        this.$store.commit('toggleSidebar')
      }
    },
    async handleLogout(message) {
      const modalInstance = this.$refs.alertConfirmModal
      const confirmed = await modalInstance.openModal(message, true)
      if (confirmed) {
        modalInstance.isVisible = false
        this.sendTrackingAction(
          this.$store.state.loginUser.userId,
          "Logout Success",
          {
            "page": "AppHeader"
          }
        ).then(() => {
          this.$store.commit('setLogoutClicked', true)
          this.$store.commit('setCurrentMenu')
          this.$store.dispatch('logOut')
        })
      }
    },
    async sendTrackingAction(starNumber, action, data){
      await imanager3Appframe.sendTrackingAction({
        starNumber: starNumber,
        pluginName: "main",
        uuid: iStoreUtils.generateTrackingUuid(),
        userAction: action,
        data: data
      })
    }
  },
  computed: {
    getVersion() {
      return Version
      // if (Subversion) {
      //   return Version + '-' + Subversion
      // } else {
      //   return Version
      // }
    },
  }
}
</script>
